import { useMemo } from "react";

import { useWebsitesFavicons } from "app/services/sitesService/hooks/useWebsitesFavicons";

import { useActivationSet } from "./useActivationSet";
import { useSecondaryDomains } from "./useSecondaryDomains";

export const useActivationSetFavicons = () => {
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();
    const { domains: secondaryDomains, isLoading: isSecondaryLoading } = useSecondaryDomains();

    const allDomains = useMemo(
        () => Array.from(new Set([...(activationSet?.allDomains ?? []), ...secondaryDomains])),
        [activationSet?.allDomains, secondaryDomains],
    );

    const { data: favicons, isLoading: isFaviconsLoading } = useWebsitesFavicons(allDomains, undefined, {
        enabled: allDomains.length > 0,
    });

    return {
        favicons,
        isLoading: isActivationSetLoading || isSecondaryLoading || isFaviconsLoading,
    };
};
